module.exports = __webpack_public_path__ + "static/media/mobile-app-icon.4922bf85.png";